/* 🤖 this file was generated by script */
export const wiconCheckCircle = {
  name: 'check_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.5 12l3 3 6-6m5.5 3a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
